module.exports = __webpack_public_path__ + "static/media/Winfield Scott - 1852.e22b3570.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Winfield Scott - 1852.jpg
// module id = 578
// module chunks = 0